import React from 'react';
import { Menu as HLMenu } from '@headlessui/react';
import useMenuContext from './useMenuContext';

interface Props {
  children: any;
  className?: string;
  buttonRef?: any;
  'aria-label'?: string;
}

export function MenuSpan(props: Props) {
  const { refs } = useMenuContext();
  // si tu mets div à la place de Fragment tu as safari qui te style le wrapper ...
  return (
    <div ref={refs.setReference}>
      <HLMenu.Button
        ref={props.buttonRef}
        aria-label={props['aria-label']}
        as="div"
        className={props.className}
      >
        {props.children}
      </HLMenu.Button>
    </div>
  );
}
